import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Address, GlobalMessageService, GlobalMessageType, LoggerService, StateUtils, tryNormalizeHttpError, USER_ADDRESSES, UserActions } from '@spartacus/core';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { CustomCheckoutActions } from '../../../src/checkout/store/actions';
import { CustomUserAddressConnector } from '../../connectors/address/custom-user-address.connector';
import { CustomUserAddressService } from '../../facade/profile/custom-user-address.service';
import { CustomAddresses } from '../actions';

@Injectable()
export class CustomUserAddressesEffects {
  protected logger = inject(LoggerService);
  loadUserAddressesByZone$: Observable<CustomAddresses.CustomUserAddressesAction> = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomAddresses.LOAD_USER_ADDRESSES),
      map((action: CustomAddresses.LoadUserAddresses) => action.payload),
      mergeMap((payload) => {
        return this.userAddressConnector.getAllByZone(payload.userId, payload.zone).pipe(
          map((addresses: Address[]) => {
            return new CustomAddresses.LoadUserAddressesSuccess({ addresses, zone: payload.zone });
          }),
          catchError((error) => of(new CustomAddresses.LoadUserAddressesFail(tryNormalizeHttpError(error, this.logger))))
        );
      })
    )
  );

  updateUserAddressByZone$: Observable<CustomAddresses.CustomUserAddressesAction> = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomAddresses.UPDATE_USER_ADDRESS),
      map((action: CustomAddresses.UpdateUserAddress) => action.payload),
      mergeMap((payload) => {
        return this.userAddressConnector.update(payload.userId, payload.addressId, payload.address).pipe(
          map((data) => {
            // don't show the message if just setting address as default
            if (payload.address && Object.keys(payload.address).length === 1 && payload.address.defaultAddress) {
              return new CustomAddresses.LoadUserAddresses({ userId: payload.userId, zone: payload.zone });
            } else {
              return new CustomAddresses.UpdateUserAddressSuccess(data);
            }
          }),
          catchError((error) => of(new CustomAddresses.UpdateUserAddressFail(tryNormalizeHttpError(error, this.logger))))
        );
      })
    )
  );

  /**
   *  Reload addresses and notify about update success
   */
  /*   @Effect({ dispatch: false }) */
  showGlobalMessageOnUpdateSuccess$ = this.actions$.pipe(
    ofType(CustomAddresses.UPDATE_USER_ADDRESS_SUCCESS, UserActions.UPDATE_USER_ADDRESS_SUCCESS, CustomCheckoutActions.UPDATE_USER_ADDRESS_SUCCESS),
    tap(() => {
      this.loadAddresses();
      // this.showGlobalMessage('addressForm.userAddressUpdateSuccess');
    })
  );

  constructor(
    private actions$: Actions,
    private userAddressConnector: CustomUserAddressConnector,
    private userAddressService: CustomUserAddressService,
    private messageService: GlobalMessageService
  ) {}

  /**
   * Show global confirmation message with provided text
   */
  private showGlobalMessage(text: string): void {
    this.messageService.add({ key: text }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
  }

  private loadAddresses(): void {
    this.userAddressService.loadAddressesByZone();
  }

  resetAddresses$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.CLEAR_USER_MISCS_DATA, CustomAddresses.CLEAR_ADDRESSES),
      map(() => {
        return new StateUtils.LoaderResetAction(USER_ADDRESSES);
      })
    )
  );
}
